export {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  type TooltipOptions,
} from "~/ui-library/components/Tooltip/Tooltip";
